import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import { FeedContainer } from './FeedContainer';
import { FullscreenViewContainer } from './FullscreenViewContainer';
import { useOffersHistoryContext } from '../../context';
import { OfferHistory, OpenFullscreenBtn } from '../../components/Desktop';
import { mapOfferCategoriesEnums } from '../../types';

export const OfferHistoryContainer: React.FC = () => {
  const {
    state: isFullscreenViewOpened,
    setTrue: openFullscreenView,
    setFalse: closeFullscreenView,
  } = useBooleanState(false);

  const {
    data: {
      listingSpoiler: { data: offersHistorySpoilerData, isFetching },
    },
    changeFilters,
    setCategoriesFilter,
    openOfferFromHistory,
    onFullscreenButtonClick,
  } = useOffersHistoryContext();

  const handleOfferClick = React.useCallback(
    (cianId: number) => {
      openFullscreenView();
      openOfferFromHistory({ cianId });
    },
    [openFullscreenView, openOfferFromHistory],
  );

  const handleFullscreenButtonClick = React.useCallback(() => {
    openFullscreenView();
    onFullscreenButtonClick();
  }, [onFullscreenButtonClick, openFullscreenView]);

  React.useEffect(() => {
    return () => {
      changeFilters(false);
    };
  }, [changeFilters]);

  const handleFullscreenClose = React.useCallback(() => {
    if (offersHistorySpoilerData?.filters?.activeCategory) {
      setCategoriesFilter(mapOfferCategoriesEnums[offersHistorySpoilerData.filters.activeCategory]);
    }
  }, [offersHistorySpoilerData?.filters?.activeCategory, setCategoriesFilter]);

  return (
    <OfferHistory
      offersTableSmall={<FeedContainer onOfferClick={handleOfferClick} isSpoiler />}
      fullscreenViewBtn={
        offersHistorySpoilerData?.totalCountText && !isFetching ? (
          <OpenFullscreenBtn onClick={handleFullscreenButtonClick} text={offersHistorySpoilerData.totalCountText} />
        ) : undefined
      }
      fullscreenView={
        <FullscreenViewContainer
          openFullscreenView={openFullscreenView}
          closeFullscreenView={closeFullscreenView}
          isFullscreenViewOpened={isFullscreenViewOpened}
          onClose={handleFullscreenClose}
        />
      }
    />
  );
};
